<button
  type="button"
  [disabled]="disabled() || loading()"
  class="inline-flex items-center justify-center gap-2 rounded-full px-6 min-h-[48px] font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer w-full"
  [ngClass]="variantClasses()"
  (click)="handleClick($event)"
>
  <ng-content />

  @if (loading()){
  <span class="button-loader animate-spin"></span>
  }
</button>
